const validateOIDCSettings = (function(oidcSettings) {
    if (!oidcSettings.authority) {
        throw 'authority is missing from oidc settings obj';
    }

    if (!oidcSettings.clientId) {
        throw 'clientId is missing from oidc settings obj';
    }

    if (!oidcSettings.scopes) {
        throw 'scopes is missing from oidc settings obj';
    }

    if (!oidcSettings.postLogoutRedirectUri) {
        throw 'clientId is missing from oidc settings obj';
    }

    if (!oidcSettings.redirectUri) {
        throw 'redirectUri is missing from oidc settings obj';
    }
});

export default validateOIDCSettings;